import { Culture } from '../../types';

export const seneca: Culture = {
  name: 'Seneca',
  languageFamily: 'Iroquoian',
  terms: [
    {
      word: 'Deadiyoh',
      phonetic: 'day-ah-dee-yoh',
      description: 'Seneca word for "tree."'
    },
    {
      word: 'Gaiwiyo',
      phonetic: 'guy-wee-yoh',
      description: 'Seneca term meaning "good message."'
    },
    {
      word: 'Ha’tsi:yo',
      phonetic: 'hah-tsee-yoh',
      description: 'Seneca word meaning "my friend."'
    },
    {
      word: 'Nya:wëh',
      phonetic: 'nyah-weh',
      description: 'Seneca word meaning "thank you."'
    },
    {
      word: 'Ongweoweh',
      phonetic: 'ohng-way-oh-weh',
      description: 'Seneca word meaning "original people."'
    }
  ]
};